const templateWizardTemplates = {
  web: `{{#if response}}
   <style></style>
   <div class="rlv-recommender" id="releva-recommender-{{token}}">
   <div class="font-wrapper">
      <h2 id="productBlockTopCallToAction"></h2>
      <link rel="stylesheet" type="text/css" href=" https://releva.ai/sdk/lib/tiny-slider/2.9.3/tiny-slider.css">
      <div class="block-title">
        <h3 id="productBlockTitle">{{title}}</h3>
      </div>
      <button aria-label="Back" tabindex="-1" class="btn-prev">
         <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" fill="none" viewBox="0 0 12 20" style="vertical-align: middle;">
            <path stroke="rgb(192, 192, 192)" stroke-width="1.5" d="m11 19-9-9 9-9"></path>
         </svg>
      </button>
      <button aria-label="Forward" tabindex="-1" class="btn-next">
         <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" fill="none" viewBox="0 0 12 20" style="vertical-align: middle;">
            <path stroke="rgb(192, 192, 192)" stroke-width="1.5" d="m1 1 9 9-9 9"></path>
         </svg>
      </button>
      <div class="block-content">
         <div>
            <div class="product-items"  onload="
              var container = this;
              var s = document.createElement('script');
              s.setAttribute('src','https://releva.ai/sdk/lib/tiny-slider/2.9.3/tiny-slider.js');
              s.onload = function() {
                tns({
                  mouseDrag: true,
                  gutter: 15,
                  container: container,
                  loop: false,
                  prevButton: '#releva-recommender-{{token}} .btn-prev',
                  nextButton: '#releva-recommender-{{token}} .btn-next',
                  items: 1,
                  edgePadding: 0,
                  navPosition: 'bottom',
                  nav: false,
                  speed: 750,
                  slideBy: 1,
                  responsive: {
                    380: {
                      items: 2,
                      edgePadding: 0
                    },
                    768: {
                      items: 3,
                      edgePadding: 0
                    },
                    1024: {
                      items: 4,
                      edgePadding: 0
                    },
                    1200: {
                      items: 5,
                      edgePadding: 0
                    }
                  }
                });
              };
              document.body.appendChild(s); document.getElementById('releva-recommender-{{token}}').style.display = 'block';">
              {{#each response}}
              <div class="product-item">
                 <div class="product-item-info">
                    <div style="position:relative; text-align:center; margin:0 auto">
                       <a href="{{url}}" class="product-item-photo">
                       <img loading="lazy" src="{{imageUrl}}" alt="{{name}}" style="max-width:100%;" referrerpolicy="no-referrer">
                       {{#if discountPrice}}
                       <strong class="rlv-discount-badge">-{{toFixed discountPercent 0}}%</strong>
                       {{/if}}
                       </a>
                    </div>
                    <div class="product-item-details">
                       <strong class="product-item-name">
                       <a href="{{url}}" class="productBlockProductTitle" tabindex="0">
                       {{name}}</a>
                       </strong>
                       <div class="rlv-price" style="margin: 0 auto; text-align: center;">
                          {{#if discountPrice}}
                          <span class="rlv-price-discountPrice">{{formatPrice this "discountPrice"}}</span>
                          <span class="rlv-price-listPriceDiscounted">{{formatPrice this "listPrice"}}</span>
                          {{else}}
                          <span class="rlv-price-listPrice">{{formatPrice this "listPrice"}}</span>
                          {{/if}}
                       </div>
                    </div>
                 </div>
              </div>
              {{/each}}
            </div>
         </div>
      </div>
      <h3 id="productBlockBottomCallToAction"></h3>
      </div>
   </div>
  {{/if}}`,
  email: `<style type="text/css">#outlook a {	padding:0;}.es-button {	mso-style-priority:100!important;	text-decoration:none!important;}a[x-apple-data-detectors] {	color:inherit!important;	text-decoration:none!important;	font-size:inherit!important;	font-family:inherit!important;	font-weight:inherit!important;	line-height:inherit!important;}.es-desk-hidden {	display:none;	float:left;	overflow:hidden;	width:0;	max-height:0;	line-height:0;	mso-hide:all;}[data-ogsb] .es-button {	border-width:0!important;	padding:10px 20px 10px 20px!important;}@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:30px!important; text-align:center } h2 { font-size:26px!important; text-align:center } h3 { font-size:20px!important; text-align:center } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:30px!important } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } a.es-button, button.es-button { font-size:20px!important; display:block!important; border-width:10px 0px 10px 0px!important } .es-adaptive table, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:500px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } }</style>
<div class="es-wrapper-color" style="width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
   <div class='font-wrapper'>
      <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
         <tr>
            <td valign="top" style="padding:0;Margin:0">
               <table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
                  <tr>
                     <td align="center" style="padding:0;Margin:0">
                        <table class="es-content-body" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:100%">
                        {{#each products}}
                           {{#ifEven}}
                           <tr>
                           {{/ifEven}}
                              <td align="center" style="padding:10px;Margin:0;width:220px">
                                 <table cellpadding="0" cellspacing="0" class="es-left" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
                                    <tr>
                                       <td align="center" style="padding:0;Margin:0;width:220px">
                                          <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:separate;border-spacing:0px;border-top-left-radius:10px;border-top-right-radius:10px;border-bottom-right-radius:10px;border-bottom-left-radius:10px" role="presentation">
                                             <tr>
                                                {{#ifZero discount}}
                                                <td align="right" style="padding:10px;Margin:0;">
                                                   <p style="display:inline-block; border-radius:10px; background-color:transparent; padding:10px; Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:14px;color:#ffffff;font-size:16px"><strong></strong></p>
                                                </td>
                                                {{else}}
                                                <td align="right" style="Margin:0;">
                                                   <p class="rlv-discount-badge" style="display:inline-block; border-radius:10px; background-color:#da2728; padding:10px; Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:14px;color:#ffffff;font-size:16px"><strong>-{{toFixed discountPercent 0}}%</strong></p>
                                                </td>
                                                {{/ifZero}}
                                             </tr>
                                             <tr>
                                                <td align="center" style="padding:0;Margin:0;font-size:0px; width:210px;"><a href="{{addUtm url}}"><img class="adapt-img" src="{{imageUrl}}" alt style="width:100%; max-height:282px;display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" referrerpolicy="no-referrer"></a></td>
                                             </tr>
                                             <tr>
                                                <td align="center" style="padding:0;Margin:0">
                                                   <a href="{{addUtm url}}" style="text-decoration:none;"><p class="productBlockProductTitle" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;Margin:0;color:#000;font-size:14px;font-weight:700;">{{truncate name 70}}</p></a>
                                                </td>
                                             </tr>
                                             {{#ifZero discount}}
                                             <tr>
                                                <td align="center" style="padding:0;Margin:0">
                                                   <span style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:17px;color:#989898;font-size:11px">&nbsp;</span><span class="rlv-price-listPrice" style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#000;font-size:14px;font-weight: 700;">{{formatPrice this "price"}}</span>
                                                </td>
                                             </tr>
                                             {{else}}
                                             <tr>
                                                <td align="center" style="padding:0;Margin:0">
                                                   <span class="rlv-price-listPriceDiscounted" style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:17px;color:#989898;font-size:11px">{{formatPrice this "listPrice"}}</span> <span class="rlv-price-discountPrice" style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#da2728;font-size:14px;font-weight: 700;">{{formatPrice this "discountPrice"}}</span>
                                                </td>
                                             </tr>
                                             {{/ifZero}}
                                          </table>
                                       </td>
                                    </tr>
                                 </table>
                              </td>
                           {{#ifOddOrLast}}
                           </tr>
                           {{/ifOddOrLast}}
                        {{/each}}
                        </table>
                     </td>
                  </tr>
               </table>
            </td>
         </tr>
      </table>
   </div>
</div>`,
  search: `{{#if products}}
  <style>
    .releva-autocomplete-search {
      display: flex;
      background-color: #fff;
      width: 100%;
      margin-top: 10px;
      position: absolute;
      right: 0;
      top: 100%;
      border-radius: 6px;
      background-color: #fff;
      z-index: 1000;
      padding: 15px;
      box-shadow: 0px 0px 4px #aaa;
      max-height: 528px;
      overflow: auto;
    }
    
      
    .releva-autocomplete-search hr {
      margin: 0;
    }
  
    .releva-autocomplete-search .releva__filters {
      flex: 0 0 25%;
      width: 25%;
      padding-right: 10px;
    }
    
    .releva-autocomplete-search .releva__filters p {
      padding-left: 7px;
      padding-right: 7px; 
    }
    
    .releva-autocomplete-search .releva__filter-options p {
      cursor: pointer;
      white-space: normal;
      color: #000;
    }
    
    .releva-autocomplete-search .releva__filter-options p.selected {
      position: relative;
      background-color: #636262;
      padding-right: 22px;
      color: #fff;
      font-weight: 700;
    }
    
    .releva-autocomplete-search .releva__filter-options p.selected:after {
      content: 'X';
      display: inline-block;
      font-size: 20px;
      position: absolute;
      top: 0;
      right: 5px;
      line-height: 1;
      font-weight: 700;
    }
    
    .releva-autocomplete-search .releva__filter {
      margin-bottom: 20px;
    }
  
    .releva-autocomplete-search .releva__products {
      display: flex;
      flex-wrap: wrap;
      flex: 0 0 75%;
      width: 75%;
    }
  
    .releva-autocomplete-search .releva__product-wrapper {
      /*
    if you want to have 3 products per row change below 50% to 33.3
    it should look like this:
    flex: 0 0 33.3%;
    */
      flex: 0 0 50%;
      padding: 7px;
      box-sizing: border-box;
    }
  
    .releva-autocomplete-search .releva__product {
      display: block;
      text-decoration: none;
      border: 1px solid #cbcccd;
      padding: 10px;
      display: inline-block;
      border-radius: 6px;
      transition: 0.3s;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      white-space: normal;
      word-break: break-word;
    }
  
    .releva-autocomplete-search .releva__product:hover {
      border-color: #636262;
      box-shadow: 0 0 0 1px #c6c7c8;
    }
  
    .releva-autocomplete-search .releva__product-image {
      width: 100%;
      padding-top: 100%;
      background-size: cover;
      background-position: center center;
    }
  
    .releva-autocomplete-search p {
      font-size: 14px;
      color:  #000000;
      margin: 6px 0;
    }
  
    .releva-autocomplete-search .releva__product-name {
      font-weight: 400;
      color:  #000000;
    }
  
    .releva-autocomplete-search .releva__product-price {
      margin-bottom: 0;
    }
  
    .releva-autocomplete-search .releva__product-price span {
      text-decoration: line-through;
      color: #000000;
      margin-right: 5px;
    }
  
    .releva-autocomplete-search .releva__product-price strong {
      color: #000000;
    }
  
    @media (max-width: 1000px) {
      .releva-autocomplete-search {
        width: 500px;
      }
      
      .releva-autocomplete-search .releva__product-wrapper {
        flex: 0 0 50%;
      }
    }
    
    @media (max-width: 600px) {
      .releva-autocomplete-search {
        width: 100vw;
        position: fixed;
        top: 70px;
        left: 0;
        right: 0;
      }
    }
  </style>
  
  <div class="releva-autocomplete-search">
    <div class="releva__filters">
      {{#each filters}}
      <div class="releva__filter">
        <p><strong>{{title}}</strong></p>
        <hr>
        <div class="releva__filter-options" data-key="{{key}}" data-type="{{type}}">
          {{#each options}}
            <p data-value="{{value}}" class="{{#if selected}}selected{{/if}}">{{label}}</p>
          {{/each}}
        </div>
      </div>
      {{/each}}
    </div>
    <div class="releva__products">
      {{#each products}}
      <div class="releva__product-wrapper">
        <a href="{{addUtm url}}" class="releva__product">
          <div
            class="releva__product-image"
            style="background-image: url('{{imageUrl}}');"
          ></div>
  
          <p class="releva__product-name">{{truncate name 45}}</p>
  
          <p class="releva__product-price">
            {{#if discountPercent}}
            <span>{{formatPrice this "listPrice" }}</span>
            {{/if}}
            <strong>{{formatPrice this "price"}}</strong>
          </p>
        </a>
      </div>
      {{/each}}
    </div>
  </div>
  {{/if}}`,
};

export default templateWizardTemplates;
